export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/resume_writing.1e23746.svg";